interface I_OCR_ERROR {
  api_response: Record<"result_code" | "result_message", string>;
  review_result: Record<"error_detail", string>;
}
interface I_FACE_SERVER_ERROR {
  response: { data: { return_msg: Record<"return_code" | "return_msg", string> } };
}

class Utils {
  isError = (error: unknown): error is Error => {
    return typeof error === "object" && error !== null /* && "message" in error */;
  };
  isOCRError = (error: unknown): error is Error & I_OCR_ERROR => {
    return (
      this.isError(error) &&
      "api_response" in error &&
      typeof (error.api_response as Record<"result_code", unknown>).result_code === "string" &&
      typeof (error.api_response as Record<"result_message", unknown>).result_message === "string" &&
      "review_result" in error &&
      typeof (error.review_result as Record<"error_detail", unknown>).error_detail === "string"
    );
  };
  isFaceServerError = (error: unknown): error is Error & I_FACE_SERVER_ERROR => {
    return (
      this.isError(error) &&
      "response" in error &&
      typeof (error as Record<"response", unknown>).response === "object" &&
      typeof (error.response as Record<"data", unknown>).data === "object" &&
      typeof ((error.response as Record<"data", unknown>).data as Record<"return_msg", unknown>).return_msg ===
        "string" &&
      typeof ((error.response as Record<"data", unknown>).data as Record<"return_code", unknown>).return_code ===
        "string"
    );
  };
}

export default new Utils();
